export default "__VITE_ASSET__d0519cb1__"